<template>
  <PVToast position="bottom-left">
    <template #message="{ message: { severity, summary } }">
      <div class="flex flex-column items-start flex-1">
        <div class="flex items-center gap-2">
          <span
            class="p-3 ml-1 rounded-md text-secondary-900"
            :class="{
              'bg-green-100': severity === 'success',
              'bg-red-100': severity === 'error',
              'bg-blue-sea-100': severity === 'info',
            }">
            <Check v-if="severity === 'success'" :size="10" />
            <X v-if="severity === 'error'" :size="10" />
            <Info v-if="severity === 'info'" :size="10" />
          </span>
          <span class="text-sm text-secondary-900">{{ summary }}</span>
        </div>
      </div>
    </template>
  </PVToast>
</template>

<script setup lang="ts">
import PVToast from 'primevue/toast';
import { Check, X, Info } from 'lucide-vue-next';
</script>
